<div class="spinner-container" [hidden]="!visible">
    <i class="fa fa-cog fa-spin" [ngClass]="size" style="color: white"></i>
    <br/>
    <span class="loading-text">{{ text }}</span>
</div>
